export default __webpack_public_path__ + "static/media/flame-logo.2ec95ecc.png";